document.addEventListener("DOMContentLoaded", function () {
    // Find all tag elements
    const tagElements = document.querySelectorAll(".tag-link");

    // Add click event listener to each tag
    tagElements.forEach((tag) => {
        tag.addEventListener("click", function (e) {
            // Stop the event from bubbling up to parent elements
            e.stopPropagation();
            e.preventDefault();

            const tagSlug = this.getAttribute("data-slug");
            window.location.href = `/posts/${tagSlug}`;
        });

        // Add cursor pointer to indicate clickability
        tag.style.cursor = "pointer";
    });
});
